import { Sparkles } from "lucide-react";
import { cn } from "@/lib/utils";

/**
 * Shown in place of the email form everywhere once the user is on the waitlist.
 */
export function WaitlistJoinedMessage({ className, "data-testid": dataTestId }) {
  return (
    <div
      data-testid={dataTestId}
      className={cn(
        "mx-auto max-w-lg rounded-2xl border border-violet-500/20 bg-violet-500/[0.08] px-5 py-4 text-left sm:text-center",
        className
      )}
      role="status"
    >
      <div className="flex flex-col items-center gap-2 sm:flex-row sm:justify-center sm:gap-3">
        <Sparkles className="h-5 w-5 shrink-0 text-violet-300" aria-hidden />
        <div className="min-w-0 space-y-1">
          <p className="text-sm font-semibold text-violet-100">
            You are on the waitlist
          </p>
          <p className="text-xs leading-relaxed text-violet-200/55">
            We will email you when your spot opens. You do not need to enter your
            email again.
          </p>
        </div>
      </div>
    </div>
  );
}
